import React, { useEffect, useState } from "react";
import styles from "./ModifyBankModal.module.scss";
import {
  Box,
  Checkbox,
  Fade,
  FormControl,
  FormControlLabel,
  FormGroup,
  IconButton,
  Modal,
  Radio,
  RadioGroup,
  Stack,
  TextField,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { Formik, Form, useFormikContext } from "formik";
import * as Yup from "yup";
import Close from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";
import {
  PrimaryBankRequestBankUpdateAPICall,
  UpdatePrimaryBankUpdateAPICall,
} from "../BankUpdateAPICalls";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";

const schema = Yup.object().shape({
  bankAccountNumber: Yup.string()
    .required("Account Number is Required")
    .min(6)
    .max(18)
    .matches(/^[a-zA-Z0-9 ]*$/, "Enter Valid Account Number")
    .transform((value: any) => value && value.toUpperCase()),

  ConfirmBankAccountNumber: Yup.string()
    .required("Confirm Account Number is Required")
    .min(6)
    .max(18)
    .matches(/^[a-zA-Z0-9 ]*$/, "Enter Valid Account Number")
    .transform((value: any) => value && value.toUpperCase())
    .test(
      "match",
      "Account Number and Confirm Account Number should match",
      function (value) {
        return value === this.parent.bankAccountNumber;
      }
    ),

  ifscNumber: Yup.string()
    .required("IFSC is Required")
    .max(11)
    .matches(/^[a-zA-Z0-9 ]*$/, "Enter Valid IFSC")
    .transform((value: any) => value && value.toUpperCase()),
});

function ModifyBankModal({ showModal, bankData, handleCloseModifyModal }) {
  const navigate = useNavigate();
  const [checkedOptions2, setCheckedOptions2] = useState(true);
  const [checkedOptions1, setCheckedOptions1] = useState(false);
  const [micrNumber, setMicrNumber] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [sendotpLoading, setsendotpLoading] = useState(false);
  const [ifscData, setIFSCData] = useState<any>({
    Bank: "",
    Address: "",
  });
  const [fetchedbankDetails, setfetchedbankDetails] = useState({
    bankAddress: "",
    bankName: "",
    branchName: "",
  });

  const handleChangeField = (
    name: string,
    value: any,
    callBack: any,

    values: any
  ) => {
    const ifscCode = value.toUpperCase();
    //  console.log(ifscCode);
    callBack(name, ifscCode);
    if (ifscCode.length === 11) {
      fetch(`https://ifsc.razorpay.com/${ifscCode}`)
        .then((response) => response.json())
        .then((data) => {
          // callBack("micrNumber", data.MICR === null ? "Not Found" : data.MICR);
          setMicrNumber(data.MICR === null ? "" : data.MICR);
          // console.log("data", data);
          if (data === "Not Found") {
            setErrorMessage("Please enter Valid IFSC");
            setIFSCData({
              Bank: "",
              Address: "",
            });
          }
          if (data !== "Not Found") {
            setfetchedbankDetails({
              bankAddress: data.ADDRESS,
              bankName: data.BANK,
              branchName: data.BRANCH,
            });
            setIFSCData({
              Bank: data.BANK,
              Address: data.BRANCH,
            });
          }
          setTimeout(() => {
            setErrorMessage("");
          }, 5000);
        })
        .catch((error) => {
          //  console.log(error);
        });
    }

    if (ifscCode.length < 11) {
      setIFSCData({
        Bank: "",
        Address: "",
      });
    }
  };

  useEffect(() => {
    if (bankData?.bank_ifsc) {
      fetch(`https://ifsc.razorpay.com/${bankData.bank_ifsc}`)
        .then((response) => response.json())
        .then((data) => {
          if (data !== "Not Found") {
            setfetchedbankDetails({
              bankAddress: data.ADDRESS,
              bankName: data.BANK,
              branchName: data.BRANCH,
            });
            setIFSCData({
              Bank: data.BANK,
              Address: data.BRANCH,
            });
          }
        })
        .catch((error) => {
          //  console.log(error);
        });
    }
  }, [bankData]);

  const handleContinueEsign = () => {
    PrimaryBankRequest();
  };
  const PrimaryBankRequest = () => {
    let obj: any = {
      bank_details: {
        ifsc: bankData.bank_ifsc,
        micr: bankData.micr,
        account_no: bankData.bank_acc_number,
        address: fetchedbankDetails.bankAddress,
        bank_name: bankData.bank_name,
        branch_name: fetchedbankDetails.branchName,
      },
      request_id: null,
      bank_request_type: "Primary Bank Updation",
      make_bank_as_primary: true,
    };

    setsendotpLoading(true);
    PrimaryBankRequestBankUpdateAPICall(obj)
      .then((response: any) => {
        //  console.log("responsePrimary", response.data.data);
        setsendotpLoading(false);
        if (response.data?.data?.request_id) {
          sessionStorage.setItem("reqId", response.data.data.request_id);
          navigate("/bankupdate/esign");
        }
      })
      .catch((error: any) => {
        setsendotpLoading(false);
        if (error.response.data.error.message) {
          setErrorMessage(error.response.data.error.message);
          setTimeout(() => {
            setErrorMessage("");
          }, 5000);
        }
      });
  };

  const InitialValues: any = {
    bankAccountNumber: bankData?.bank_acc_number,
    ConfirmBankAccountNumber: bankData?.bank_acc_number,
    ifscNumber: bankData?.bank_ifsc,
  };

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={showModal}
      closeAfterTransition
      slotProps={{
        backdrop: {
          timeout: 500,
        },
      }}
    >
      <Fade in={showModal}>
        <Box className={styles.boxModalWrapper}>
          <Formik
            validationSchema={schema}
            initialValues={InitialValues}
            onSubmit={(values: any) => {
              // console.log("values", values);
            }}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,

              setFieldValue,
            }) => {
              return (
                <form
                  noValidate
                  onSubmit={handleSubmit}
                  onKeyDown={(event) => {
                    event.code === "Enter" ||
                      (event.code === "NumpadEnter" && handleSubmit());
                    // event.code.includes("Enter") && handleSubmit()
                  }}
                  style={{ width: "100%", height: "100%" }}
                >
                  <div className={styles.titleContainer}>
                    <IconButton onClick={handleCloseModifyModal}>
                      <ArrowBackIosIcon
                        style={{ color: "#1A1A1A", fontSize: "16px" }}
                      />
                    </IconButton>
                    Make Primary Bank Account
                  </div>
                  <div className={styles.contentWrapper}>
                    <div className={styles.noteSection}>
                      <p className={styles.note}>
                        Please map your own bank account to your trading
                        account. You cannot link a third party bank account to
                        your trading account. If modifying primary bank account,
                        post successful verification, your existing primary bank
                        will be unmapped. Charge of ₹25 + 18% GST will be levied
                        for account modification.
                      </p>
                    </div>

                    <div className={styles.textFeildSection}>
                      <div className={styles.textFeild}>
                        <TextField
                          fullWidth
                          required
                          disabled
                          name="bankAccountNumber"
                          id="outlined-basic"
                          label="Account No"
                          variant="outlined"
                          type="password"
                          value={values.bankAccountNumber?.toUpperCase()}
                          error={
                            touched.bankAccountNumber &&
                            Boolean(errors.bankAccountNumber)
                          }
                          helperText={
                            touched.bankAccountNumber &&
                            errors.bankAccountNumber?.toString()
                          }
                          onChange={handleChange}
                          onBlur={handleBlur}
                          onCopy={(e) => e.preventDefault()}
                          onPaste={(e) => e.preventDefault()}
                          inputProps={{
                            sx: {
                              "&::label": {
                                fill: "#111827",
                                fontWeight: 500,
                              },
                              color: "var(--Black-Black-500, #6B7280)",
                              fontSize: "14px",
                            },
                            maxLength: 18,

                            inputMode: "text",
                          }}
                          sx={{
                            fieldset: {
                              borderColor: "#E5E7EB",
                              borderRadius: "100px",
                              height: "55px",
                            },
                          }}
                          InputLabelProps={{
                            sx: {
                              color: "#6B7280",

                              fontWeight: 500,
                              "&.MuiFormLabel-filled": {
                                color: "#111827", // Label color when the field has a value
                              },
                            },
                          }}
                        />
                      </div>
                      <div className={styles.textFeild}>
                        <TextField
                          fullWidth
                          required
                          disabled
                          id="outlined-basic"
                          label="Re Enter Account No"
                          variant="outlined"
                          name="ConfirmBankAccountNumber"
                          value={values.ConfirmBankAccountNumber?.toUpperCase()}
                          error={
                            touched.ConfirmBankAccountNumber &&
                            Boolean(errors.ConfirmBankAccountNumber)
                          }
                          helperText={
                            touched.ConfirmBankAccountNumber &&
                            errors.ConfirmBankAccountNumber?.toString()
                          }
                          onChange={handleChange}
                          onBlur={handleBlur}
                          inputProps={{
                            sx: {
                              "&::label": {
                                fill: "#111827",
                                fontWeight: 500,
                              },
                              color: "var(--Black-Black-500, #6B7280)",
                              fontSize: "14px",
                            },
                            maxLength: 18,

                            inputMode: "text",
                          }}
                          sx={{
                            fieldset: {
                              borderColor: "#E5E7EB",
                              borderRadius: "100px",
                              height: "55px",
                            },
                          }}
                          InputLabelProps={{
                            sx: {
                              color: "#6B7280",

                              fontWeight: 500,
                              "&.MuiFormLabel-filled": {
                                color: "#111827", // Label color when the field has a value
                              },
                            },
                          }}
                        />
                      </div>
                      <div className={styles.textFeild}>
                        <TextField
                          fullWidth
                          required
                          disabled
                          name="ifscNumber"
                          id="outlined-basic"
                          label="IFSC Code"
                          variant="outlined"
                          value={values.ifscNumber?.toUpperCase()}
                          error={
                            touched.ifscNumber && Boolean(errors.ifscNumber)
                          }
                          helperText={
                            touched.ifscNumber && errors.ifscNumber?.toString()
                          }
                          onChange={(event) => {
                            handleChangeField(
                              "ifscNumber",
                              event.target.value,
                              setFieldValue,

                              values
                            );
                          }}
                          onBlur={handleBlur}
                          inputProps={{
                            sx: {
                              "&::label": {
                                fill: "#111827",
                                fontWeight: 500,
                              },
                              color: "var(--Black-Black-500, #6B7280)",
                              fontSize: "14px",
                            },
                            maxLength: 11,

                            inputMode: "text",
                          }}
                          sx={{
                            fieldset: {
                              borderColor: "#E5E7EB",
                              borderRadius: "100px",
                              height: "55px",
                            },
                          }}
                          InputLabelProps={{
                            sx: {
                              color: "#6B7280",

                              fontWeight: 500,
                              "&.MuiFormLabel-filled": {
                                color: "#111827", // Label color when the field has a value
                              },
                            },
                          }}
                        />
                      </div>
                    </div>

                    <div className={styles.checkBoxSection}>
                      <div className={styles.checkBoxDiv}>
                        <FormGroup>
                          <FormControlLabel
                            sx={{ alignItems: "flex-start" }}
                            control={
                              <Checkbox
                                name="condition1"
                                sx={{
                                  padding: "0px",
                                  "&.Mui-checked": {
                                    color: "#000",
                                  },
                                }}
                                checked={checkedOptions1}
                                onChange={(event) => {
                                  const { checked } = event.target;
                                  setCheckedOptions1(checked);
                                }}
                              />
                            }
                            label={
                              <span className={styles.label}>Set Primary</span>
                            }
                          />
                          <FormControlLabel
                            sx={{ alignItems: "flex-start" }}
                            control={
                              <Checkbox
                                name="condition3"
                                sx={{
                                  padding: "0px",
                                  "&.Mui-checked": {
                                    color: "#000",
                                  },
                                }}
                                checked={checkedOptions2}
                                onChange={(event) => {
                                  const { checked } = event.target;
                                  // setCheckedOptions2(checked);
                                }}
                              />
                            }
                            label={
                              <span className={styles.label}>
                                I/We hereby declare that the above information
                                provided by me, is true and to the best of my
                                knowledge. I/We undertake to inform Firstock
                                Broking Ltd. of any discrepancies, changes, or
                                incorrect information that I become aware of,
                                immediately. I/We understand that in case any
                                information provided above is incorrect or
                                misleading, /We would be held liable for all
                                such consequences/actions taken with respect to
                                the above information. This change will affect
                                the Trading and Demat account that I hold with
                                Firstock Broking Ltd.
                              </span>
                            }
                          />
                        </FormGroup>
                      </div>
                    </div>
                  </div>
                  <div className={styles.buttonStack}>
                    <LoadingButton
                      variant="contained"
                      type="submit"
                      loading={sendotpLoading}
                      disabled={!checkedOptions1}
                      className={styles.approveButton}
                      sx={{
                        fontSize: "12px",
                        height: "70%",
                        padding: "3px 40px",
                      }}
                      onClick={handleContinueEsign}
                    >
                      Continue
                    </LoadingButton>
                  </div>
                </form>
              );
            }}
          </Formik>
        </Box>
      </Fade>
    </Modal>
  );
}

export default ModifyBankModal;
